import './style/content.css';

function Floating(){
    return (
        <div id='FloatingItem'>
            <a className='floatWhatsapp' href='https://wa.me/+622081333570925' target='_blank' rel="noreferrer">
                <div>Whatsapp <i className='bi bi-whatsapp ms-1'></i></div>
            </a>
            <a className='toTop' href='#root'>
                <i className="bi bi-caret-up-fill"></i>
            </a>
        </div>
    )
}

export default Floating;